import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideFullScreenOverlay } from "../../../store/actions/main/widgets";
import HeaderContent from "../../headerContent";
import Sidebar from "../../sidebar";
import Scrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import "./style.css";
import { useLocation, useNavigate } from "react-router-dom";

const Page = props => {
  const {
    activePage,
    backLocation,
    backRewind,
    backText,
    backUrl,
    children,
    className,    
    isFromAccountantPage,
    isPremiumAdvice,
    marginZero,
    noClassName,
    noHeaderContent,
    servicesAgyo,
    style,
    subtitle,
    subClassName,
    title,
    topContent,
    topHeaderContent,
    isFullscreenOverlay,
    myType,
    pageRef,
    actionClick
  } = props;

  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();  
  const main = useSelector(state => state.main);

  useEffect(() => {
    if (!pageRef?.current) return undefined;
    let ps = new Scrollbar(pageRef.current, {wheelPropagation: true});
    return () => {
      if (ps) {
        ps.destroy();
        ps = null;
      }
    };
  }, [pageRef?.current]);

  useEffect(() => {
    if (main.widgets.fullscreenOverlay.visible && !isFullscreenOverlay) {
      dispatch(hideFullScreenOverlay());
    }
  }, []);
  
  const linkBack = {
    text: backText,
    pushUrl: backRewind ? "BACK" : backUrl ? backUrl : null,
    nextLocation: location.state,
    winLocation: backLocation || null,
    actionClick: actionClick ? actionClick : null
  };

  let mainClassName = isFullscreenOverlay
    ? "dbx-main-page-overlay"
    : "dbx-main-page";
  
  /**
   * BEGIN TODO: da rimuovere postDemo. Per capire se voglio o meno header e sidebar
   */
  const embedParameter = new URLSearchParams(location.search).get("embed");
  /**
   * END TODO: da rimuovere postDemo
   */
  
  return (
    <div id="dbx-main-container" ref={pageRef} className="dbx-main-page-container">
      {!isFullscreenOverlay && embedParameter == null && (
        <Sidebar activePage={activePage || location.pathname} />
      )}
      {topContent}
      <div
        id={isFullscreenOverlay ? "dbx-main-page-overlay" : "dbx-main-page"}
        style={style}
        className={
          (embedParameter === "" ? " embed " : "") +
          (noClassName
            ? mainClassName
            : className
              ? mainClassName + " " + className
              : mainClassName +
              " contentStructure" +
              (main.myType !== "STUDIO" ? " transparent" : ""))                
        }
      >
        {topHeaderContent}
        {noHeaderContent || isFullscreenOverlay ? (
          children
        ) : subClassName ? (
          <div className={subClassName}>
            <HeaderContent       
              location={location}
              navigate={navigate}       
              linkBack={linkBack}
              isFromAccountantPage={isFromAccountantPage}
              title={title}
              subtitle={subtitle}
              isPremiumAdvice={isPremiumAdvice}
              servicesAgyo={servicesAgyo}
              marginZero={marginZero || false}
              myType={myType}
            />
            {children}
          </div>
        ) : (
          <React.Fragment>
            <HeaderContent    
              location={location} 
              navigate={navigate}         
              linkBack={linkBack}
              isFromAccountantPage={isFromAccountantPage}
              title={title}
              subtitle={subtitle}
              myType={myType}
              marginZero={marginZero || false}
            />
            {children}
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default Page;
